import React from "react";

import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";
import Link from "next/link";
import Head from "next/head";

function Entry({ title, href, date }) {
  return (
    <div className="flex flex-row my-1 py-2">
      <div className="w-2/3 underline">
        <Link href={href}>
          <a>{title}</a>
        </Link>
      </div>
      <div className="w-1/3 flex flex-row justify-end">
        <p className="text-sm text-gray-500">{date}</p>
      </div>
    </div>
  );
}

export default function BlogHome() {
  window.location.href = "https://blog.uptimeline.com";
  return null;
}
